/**
 * Performs a fetch POST request with application/x-www-form-urlencoded content type
 * @param action - The URL to POST to
 * @param params - Object containing form parameters to submit
 * @returns Promise resolving to the fetch Response
 */
export const postFormEncoded = (
  action: string,
  params: Record<string, string | number | boolean>,
): Promise<Response> => {
  const formBody = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    formBody.append(key, String(value));
  });

  return fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formBody.toString(),
  });
};
